let prod = false;
let prodincloud = true;

export default {
  server: prodincloud
    ? "https://ayniapi.gootwork.com/api/v1/"
    : prod
    ? "https://ayniapi.gootwork.com/api/v1/"
    : "http://localhost:4000/api/v1/",
  serverweb: prodincloud
    ? "https://ayniapi.gootwork.com/"
    : prod
    ? "http://localhost:4000/"
    : "http://localhost:4000/",
  host: prodincloud
    ? "https://ayni.gootwork.com/"
    : prod
    ? "http://localhost:3000/"
    : "http://localhost:8080/",
};
